'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Carousel = require('../../main/jsx/Carousel');

var _Carousel2 = _interopRequireDefault(_Carousel);

var _MPPImage = require('../../../../atoms/image/jsx/MPPImage');

var _MPPImage2 = _interopRequireDefault(_MPPImage);

var _breakpoints = require('../../../../../utilities/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ORGANISM_NAME = 'image-carousel';

var ImageCarousel = function (_React$Component) {
  _inherits(ImageCarousel, _React$Component);

  function ImageCarousel(props) {
    _classCallCheck(this, ImageCarousel);

    var _this = _possibleConstructorReturn(this, (ImageCarousel.__proto__ || Object.getPrototypeOf(ImageCarousel)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      isMobile: false
    };
    return _this;
  }

  _createClass(ImageCarousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('click', this.handleNavigationClick);
      this.handleResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('click', this.handleNavigationClick);
    }

    /* Work around for checking if navigation is open/close */

  }, {
    key: 'render',
    value: function render() {
      var slides = this.props.content.slides;

      var classes = (0, _classnames2.default)(ORGANISM_NAME, this.props.className);
      return _react2.default.createElement(
        'section',
        {
          className: classes,
          'data-building-block': 'organism'
        },
        this.renderCarousel(slides)
      );
    }
  }]);

  return ImageCarousel;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleNavigationClick = function (e) {
    var el = e ? e.target : undefined;
    if (el && el.rel === 'menuitem') {
      _this2.carousel.pause();
    } else if (el && el.getAttribute('role') === 'button' && el.title === 'Close') {
      _this2.carousel.resume();
    }
  };

  this.handleResize = function (e) {
    // TODO: Explore different solution to trigger resize
    // inside an iFrame; We don't need this event
    // param; it's only for canvasnodeweb
    var newWindowWidth = e && e.iFrameWidth || window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (newWindowWidth >= _breakpoints2.default.medium) {
      if (_this2.state.isMobile) {
        _this2.setState({
          isMobile: false
        });
      }
    } else if (!_this2.state.isMobile) {
      _this2.setState({
        isMobile: true
      });
    }
  };

  this.renderImages = function (slides) {
    if (slides) {
      return slides.map(function (props) {
        return _react2.default.createElement(
          'div',
          { key: props.alt },
          _react2.default.createElement(_MPPImage2.default, _extends({}, props, { name: ORGANISM_NAME }))
        );
      });
    }
    return null;
  };

  this.renderCarousel = function (slides) {
    var autoplayInterval = _this2.props.config.autoplayInterval;


    var wrapperClass = (0, _classnames2.default)({
      'image-carousel__carousel__wrapper--single-slide': slides.length === 1
    }, ORGANISM_NAME + '__wrapper container');

    var carouselClass = slides.length === 1 ? ORGANISM_NAME + '__carousel__wrapper--single-slide ' + ORGANISM_NAME + '__carousel' : ORGANISM_NAME + '__carousel';

    var options = {
      startSlide: 0,
      speed: 400,
      auto: autoplayInterval,
      className: ORGANISM_NAME,
      continuous: false
    };

    return _react2.default.createElement(
      'div',
      {
        key: _this2.state.isMobile + slides.length,
        className: wrapperClass
      },
      _react2.default.createElement(
        _Carousel2.default,
        {
          ref: _this2.handleNavigationClick,
          className: carouselClass,
          trackId: _this2.props.config.trackId,
          options: options,
          callback: _this2.props.callback,
          content: _this2.props.content.carousel,
          numberCounterThreshold: _this2.props.config.numberCounterThreshold,
          renderNumberCounter: _this2.props.config.renderNumberCounter
        },
        _this2.renderImages(slides)
      )
    );
  };
};

exports.default = ImageCarousel;


ImageCarousel.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    autoplayInterval: _propTypes2.default.number,
    trackId: _propTypes2.default.string,
    numberCounterThreshold: _propTypes2.default.number,
    renderNumberCounter: _propTypes2.default.bool
  }),
  content: _propTypes2.default.shape({
    carousel: _propTypes2.default.shape({
      goToSlide: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }),
      goToNextSlide: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }),
      goToPreviousSlide: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      })
    }),
    slides: _propTypes2.default.arrayOf(_propTypes2.default.shape(_MPPImage2.default.propTypes)).isRequired
  }),
  callback: _propTypes2.default.func,
  className: _propTypes2.default.string
};

ImageCarousel.defaultProps = {
  config: {
    id: '',
    autoplayInterval: 0,
    trackId: 'Image-Carousel',
    numberCounterThreshold: 6,
    renderNumberCounter: false
  },
  content: {
    carousel: {
      goToSlide: {
        text: 'Go to slide'
      },
      goToNextSlide: {
        text: 'Go to next slide'
      },
      goToPreviousSlide: {
        text: 'Go to previous slide'
      }
    },
    slides: [{
      src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/page-builder/thumbnails/organisms/image-carousel-homepage-hero-placeholder-image.png',
      alt: 'Image description 1',
      className: ''
    }, {
      src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/page-builder/thumbnails/organisms/image-carousel-homepage-hero-placeholder-image.png',
      alt: 'Image description 2',
      className: ''
    }, {
      src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/page-builder/thumbnails/organisms/image-carousel-homepage-hero-placeholder-image.png',
      alt: 'Image description 3',
      className: ''
    }]
  },
  callback: function callback() {},
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/carousel/image-carousel/jsx/ImageCarousel.js
// module id = 1075
// module chunks = 4